<template>
  <div v-loading="isLoading">
    <button @click="handleCommand()"
            class="btn btn-success btn-fill btn-wd"
            title="Este botão irá adicionar o ID do evento aos registros de lâmpadas que não contenham.">
      Adicionar ID do eventos as lâmpadas trocadas
    </button>
    <el-progress :percentage="progressPercentage" />
  </div>
</template>
<script>
  import Couchdb from 'src/services/Couchdb'
  import swal from 'sweetalert2'

  export default {
    name: 'add-event-id-on-lamps',
    data () {
      return {
        isLoading: false,
        progress: 0,
        total: 0,
        eventLamps: 0,
        events: [],
        lamps: []
      }
    },
    computed: {
      progressPercentage () {
        if (this.total === 0) {
          return 0
        }
        return parseInt((this.progress / this.total) * 100)
      }
    },
    methods: {
      async handleCommand () {
        this.isLoading = true
        this.total = 0
        this.progress = 0
        try {
          this.lamps = await Couchdb.collection('lamps')
            .select(['_id'])
            .where('eventId', {'$exists': false})
            .all()
          this.total = this.lamps.length
          this.isLoading = false
          if (this.total === 0) {
            this.notifyFinish()
          } else {
            this.notifyAmount()
              .then(() => {
                try {
                  this.exec()
                } catch (e) {
                  console.log('Falha no processo', e)
                }
              })
          }
        } catch (e) {
          console.log(e)
          this.isLoading = false
        }
      },
      async exec () {
        console.log(this.events)
        if (this.events.length === 0) {
          await this.getEvents()
        }
        while (true) {
          this.lamps = await Couchdb.collection('lamps')
            .where('eventId', {'$exists': false})
            .limit(5)
            .all()
          if (this.lamps.length <= 0) {
            this.progress = this.progress < 100 ? ++this.progress : this.progress
            this.notifyFinish()
            return true
          }
          let promises = []
          for (let lamp of this.lamps) {
            for (let event of this.events) {
              if (event.startDate <= lamp.createdAt && event.endDate >= lamp.createdAt) {
                lamp.eventId = event._id
                break
              } else {
                lamp.eventId = null
              }
            }
            promises.push(
              Couchdb.collection('lamps')
                .update(lamp._id, lamp)
            )
            ++this.progress
          }
          try {
            await Promise.all(promises)
          } catch (e) {
            console.log('Error when was updating the lamp', e)
          }
        }
      },
      notifyAmount () {
        return swal({
          title: 'Lâmpadas',
          html: `Deseja inserir o ID do evento nas ${this.total} trocas de lâmpadas?`,
          type: 'info',
          showCancelButton: true,
          confirmButtonText: 'Sim, inserir ID!',
          cancelButtonText: 'Não',
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          buttonsStyling: false
        })
      },
      notifyFinish () {
        this.total = 1
        this.progress = 1
        this.eventLamps = 1
        swal({
          title: 'Sucesso',
          text: `Todas as lâmpadas foram atualizadas com seus respectivos ID dos eventos`,
          type: 'success',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        })
      },
      async getEvents () {
        this.events = await Couchdb.collection('events')
          .select(['startDate', 'endDate', '_id'])
          .all()
        return true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/commands/AddEventIdOnLamps.vue